export function useTable() {
  function calculateHeight() {
    const total = window.innerHeight;
    const header = document.querySelector('.v-app-bar--fixed');
    const filtersBar = document.querySelector('.filters-bar');
    const pagination = document.querySelector('.base-table-pagination');
    const headerHeight = (header as HTMLElement)?.offsetHeight | 0;
    const filtersBarHeight = (filtersBar as HTMLElement)?.offsetHeight | 0;
    const paginationHeight = (pagination as HTMLElement)?.offsetHeight | 0;
    // 64 - it's title container, 30 - it's container top + bottom paddings
    const elementsHeight = headerHeight + paginationHeight + filtersBarHeight + 30 + 64;
    // @ts-ignore
    return total - elementsHeight - (this.$vuetify.breakpoint.xs ? -55 : 0);
  }

  return {
    calculateHeight,
  };
}
